var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-header',{attrs:{"title":"舌诊","isReturn":"true"}}),_c('camera',{attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }